import { styled } from "@mui/material";
import { FC, ReactNode } from "react";

interface ReadonlyProps {
  value: ReactNode;
  label: string;
  href?: string;
}

const ReadonlyContainer = styled("div")`
  padding: 0.5em 0;
  width: 100%;
`;

const Label = styled("div")`
  font-size: 0.8em;
  font-weight: bold;
`;

const Value = styled("div")`
  margin-top: 0.2em;
`;

const Link = styled("a")`
  color: inherit;
`;

const Readonly: FC<ReadonlyProps> = ({ href, label, value }) => {
  const getValue = () => {
    if (typeof value === "undefined" || value === null) {
      return "---";
    }
    if (typeof value === "boolean") {
      return value ? "Yes" : "No";
    }
    return value;
  };

  return (
    <ReadonlyContainer>
      <Label>{label}</Label>
      <Value>
        {href ? (
          <Link href={href} target="_blank" rel="noopener noreferrer">
            {getValue()}
          </Link>
        ) : (
          getValue()
        )}
      </Value>
    </ReadonlyContainer>
  );
};

export { Readonly };
